import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "47",
  height: "47",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g stroke=\"#6BB193\" stroke-width=\"3\" clip-path=\"url(#a)\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M41.104 17.615a7.335 7.335 0 0 1-7.34-7.381 7.277 7.277 0 0 1-7.893.63A7.339 7.339 0 0 1 22.607 1.5a22.008 22.008 0 1 0 21.851 15.275 7.262 7.262 0 0 1-3.354.839Z\"></path><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M14.635 24.947a4.406 4.406 0 1 0 0-8.812 4.406 4.406 0 0 0 0 8.812ZM27.853 36.697a2.938 2.938 0 1 0 0-5.875 2.938 2.938 0 0 0 0 5.875Z\"></path><path d=\"M13.904 33.76a.734.734 0 1 1 0-1.469M13.904 33.76a.734.734 0 0 0 0-1.469M25.65 20.541a.734.734 0 1 1 0-1.469M25.65 20.541a.734.734 0 1 0 0-1.469M37.4 26.416a.734.734 0 0 1 0-1.469M37.4 26.416a.734.734 0 1 0 0-1.469\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h47v47H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }